import React from 'react';
import { Stack } from '@mui/material';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import RecoveringPassword from './recoveringPassword';
import RecoveringPasswordCode from './recoveringPasswordCode';

export default () => {
  const { path } = useRouteMatch();

  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ height: '100vh', overflowY: 'auto' }}
      flexGrow={0}
      flexShrink={1}
      flexBasis="700px"
    >
      <Switch>
        <Route exact path={path} component={RecoveringPassword} />
        <Route exact path={`${path}/code`} component={RecoveringPasswordCode} />
      </Switch>
    </Stack>
  );
};
